import { createAction } from '@reduxjs/toolkit';
import { saveVehicleFormValues } from './vehicle_form';
import {
  saveJourneyFormValues,
  setJourneyDates,
  setJourneys,
  saveReservationId,
  setSegmentStop,
} from './journey_form';
import { savePassengerFormValues } from './passenger_form';
import {
  saveServiceFormValues,
  saveOriginalServiceFormValues,
} from './service_form';
import {
  saveAccommodationSearchFormValues,
  saveAccommodationSearchResults,
  setAccommodationCurrentProvider,
  setAccommodationCurrentRoom,
  setAccommodationCurrentTotalPrice,
} from './accommodation_form';

const setMetaFlow = createAction('ui/sealink/setMetaFlow');
const setFerryGrouping = createAction('ui/sealink/setFerryGrouping');
const setBookingTenant = createAction('ui/sealink/setBookingTenant');

export {
  setMetaFlow,
  setFerryGrouping,
  saveJourneyFormValues,
  setJourneyDates,
  setJourneys,
  setSegmentStop,
  saveReservationId,
  savePassengerFormValues,
  saveVehicleFormValues,
  saveServiceFormValues,
  saveOriginalServiceFormValues,
  saveAccommodationSearchFormValues,
  saveAccommodationSearchResults,
  setAccommodationCurrentProvider,
  setAccommodationCurrentRoom,
  setAccommodationCurrentTotalPrice,
  setBookingTenant,
};
